import { dayMs, hourMs, minuteMs } from "verdi-common/timeConstants";

export const EVENT_DURATION_UPPER_BOUND_MS = 2 * dayMs;
export const EVENT_DURATION_LOWER_BOUND_MS = 5 * minuteMs;
export const EVENT_MAX_FUTURE_START_MS = 6 * hourMs;
